import Cookies from 'js-cookie'
import posthog from 'posthog-js'
import { POSTHOG_COOKIE_KEY } from '../utils'

const getDistinctID = (): string | null => {
	const posthogData = Cookies.get(POSTHOG_COOKIE_KEY)
	if (!posthogData) return null

	const parsedData = JSON.parse(posthogData)

	if (parsedData.distinct_id) {
		return parsedData.distinct_id
	} else {
		return null
	}
}

const identifyPosthogUser = (data: Record<string, unknown>) => {
	const distinctID = getDistinctID()
	if (distinctID) {
		posthog.identify(distinctID, data)
	}
}

export default identifyPosthogUser
